import { useContext } from "react"
import { P } from "../../../../auth/permissions"
import BaseDocumentElement from "../../../../components/elements/BaseDocumentElement"
import BaseSection from "../../../../components/elements/BaseSection"
import { ModalContext } from "../../../../components/contexts/ModalContext"
import { SidePanelContext } from "../../../../components/contexts/SidePanelContext"
import { DocumentDataType } from "../../../../components/types"

type ObjectDetailPartRightType = {
    setfileToDelete: (e: string) => void
    setselectedS3Key: (e: string) => void
    documents?: DocumentDataType[]
    handleDownload: (e: string, f: string) => void
}

export default function ObjectDetailPartRight(props: ObjectDetailPartRightType) {
    const modalCon = useContext(ModalContext)
    const sidePanelCon = useContext(SidePanelContext)
    const obvFound = props.documents?.find((item) => item?.tags?.includes("Objektbetreuungsvertrag"))

    if (!obvFound) return null

    return (
        <BaseSection classProps="!grow">
            <BaseDocumentElement
                obv
                title={obvFound.title}
                permissions={[P.objekte_read_write]}
                timestamp={obvFound.timestamp}
                downloadFunc={() => props.handleDownload(obvFound.s3Key, obvFound.title)}
                deleteFunc={() => {
                    props.setfileToDelete(obvFound.s3Key)
                    modalCon?.trigger(4)
                }}
                showPreviewFunc={() => {
                    props.setselectedS3Key(obvFound.s3Key)
                    sidePanelCon?.trigger(6)
                }}
            />
        </BaseSection>
    )
}
